'use client'

import { useState } from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { useTranslations } from 'next-intl'
import { Anchor, Box, Container, Grid, GridCol, Group, Stack, Text, Title } from '@mantine/core'
import LegalModal from './LegalModal'
import { LuMail } from 'react-icons/lu'

const footerItems = ['privacyPolicy', 'termsAndConditions', 'impress'] as const

type FooterItem = (typeof footerItems)[number]

export default function GlobalFooter() {
    const t = useTranslations('footer')
    const tHome = useTranslations('home')
    const [activeItem, setActiveItem] = useState<FooterItem | null>(null)
    const activeTitle = activeItem ? t(`items.${activeItem}`) : ''

    return (
        <>
            <Box component='footer' py={80} bg='var(--eltrust-color-ink)' c='var(--mantine-color-gray-3)'>
                <Container size='xl'>
                    <Grid>
                        <GridCol span={{ base: 12, sm: 4, md: 3 }}>
                            <Anchor
                                component={Link}
                                href='/'
                                display='block'
                                w='fit-content'
                                aria-label={tHome('footer.logoLinkAriaLabel')}
                                mb='md'>
                                <Image src='/logo/logo-light.svg' alt='' width={120} height={120} />
                            </Anchor>

                            <Text fz='sm' c='white'>
                                {tHome('copyright')}
                            </Text>
                        </GridCol>

                        <GridCol span={{ base: 6, sm: 4, md: 3 }}>
                            <Title order={4} mb='md' c='white'>
                                {tHome('footer.linksHeading')}
                            </Title>
                            <Stack gap='sm'>
                                <Anchor href='#' c='white' fz='sm'>
                                    {tHome('footer.links.about')}
                                </Anchor>
                                <Anchor href='#' c='white' fz='sm'>
                                    {tHome('footer.links.services')}
                                </Anchor>
                                <Anchor href='#' c='white' fz='sm'>
                                    {tHome('footer.links.partner')}
                                </Anchor>
                                <Anchor href='#' c='white' fz='sm'>
                                    {tHome('footer.links.testimonials')}
                                </Anchor>
                            </Stack>
                        </GridCol>

                        <GridCol span={{ base: 6, sm: 4, md: 3 }}>
                            <Title order={4} mb='md' c='white'>
                                {tHome('footer.legalHeading')}
                            </Title>
                            <Stack gap='sm'>
                                <Anchor href='#' c='white' fz='sm'>
                                    {tHome('footer.legal.privacy')}
                                </Anchor>
                                <Anchor href='#' c='white' fz='sm'>
                                    {tHome('footer.legal.imprint')}
                                </Anchor>
                            </Stack>
                        </GridCol>

                        <GridCol span={{ base: 12, sm: 12, md: 3 }}>
                            <Title order={4} mb='md' c='white'>
                                {tHome('footer.contactHeading')}
                            </Title>
                            <Anchor href='mailto:info@eltrust.ch' c='white' fz='sm'>
                                <Group gap='xs'>
                                    <LuMail size={20} />
                                    <Text>info@eltrust.ch</Text>
                                </Group>
                            </Anchor>
                        </GridCol>
                    </Grid>
                </Container>
            </Box>

            <LegalModal opened={activeItem !== null} onClose={() => setActiveItem(null)} title={activeTitle} />
        </>
    )
}
